import { message, notification } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../../services/authApi";
import AuthLayout from "./../../../components/auth/authLayout";
import {
    setAccessToken
} from "./../../../helper/localStorage";
import "./index.scss";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { nofication } from './../../../commons/Nofication'
const Login = () => {
    const history = useNavigate();
    const [valueForm, setValueForm] = useState({
        email: "",
        password: "",
    });

    useEffect (() => {
        if (localStorage.getItem('ACCESS_TOKEN_STORED')){
            history("/dashboard");
        }
    })

    const onChangeValue = (values) => {
        setValueForm({
            ...valueForm,
            [values.target.name]: values.target.value,
        });
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        if(!valueForm.email){
            message.error('Xin vui lòng nhập email');
            return;
        }
        if(!valueForm.password){
            message.error('Xin vui lòng nhập mật khẩu');
            return;
        }
        const res = await authApis
            .login(valueForm)
            .then((data) => {
                console.log(data)
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Đăng nhập thành công!');
                    setAccessToken(data.token);
                    localStorage.setItem('username', data.username);
                    localStorage.setItem('id', data.id);
                    localStorage.setItem('avatar', data.avatar);
                    history("/dashboard");
                }else{
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại tài khoản mật khẩu !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
        return res;
    };

    return (
        <AuthLayout>
            <div className="col-xl-12">
                <div className="p-4">
                    <div className="text-center">
                        <h3
                            className="h5 text-gray-900 mb-4"
                            style={{ fontWeight: "bold" }}
                        >
                            Welcome to Delta School
                        </h3>
                    </div>
                    <form className="user" method="post" onSubmit={onSubmit}>
                        <div className="form-group">
                            <input
                                type="email"
                                className="form-control"
                                id="exampleInputEmail"
                                aria-describedby="emailHelp"
                                placeholder="Email"
                                name="email"
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                type="password"
                                className="form-control"
                                id="exampleInputPassword"
                                placeholder="Password"
                                name="password"
                                onChange={onChangeValue}
                            />
                        </div>
                        <div className="form-group">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="form-group mt-3">
                                    <div className="custom-control custom-checkbox small">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="customCheck"
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="customCheck"
                                            style={{
                                                marginLeft: "24px",
                                            }}
                                        >
                                            Remember Me
                                        </label>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn"
                                    style={{
                                        color: "white",
                                        background: "black",
                                        padding: "5px 20px",
                                    }}
                                >
                                    Sign in
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="text-left">
                        <Link
                            className="small"
                            to="/forgot-password"
                            style={{ color: "red" }}
                        >
                            I forgot my password?
                        </Link>
                    </div>
                    {/* <div className="text-left">
                        <Link
                            className="small"
                            to="/register"
                            style={{ color: "black" }}
                        >
                            Register a new membership
                        </Link>
                    </div> */}
                </div>
            </div>
        </AuthLayout>
    );
};

export default Login;
